// extracted by mini-css-extract-plugin
module.exports = {"Banner":"style_Banner__2LzCL","Banner_show":"style_Banner_show__3u1fK","Wrapper":"style_Wrapper__22Qhn","Close":"style_Close__3Fi__","Content":"style_Content__3O5NI"};